import './NotifyRequest.sass';

import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from '$uikit';
import { mainActions, mainSelector } from '$store/main';
import { subscribe } from '$services/push';
import { isIOS, isNotificationsSupported, isPWA } from '$utils';
import { useTranslator } from '$hooks';
import { PwaModal } from '$core';

export const NotifyRequest: FC = () => {
  const { isNotifyEnabled } = useSelector(mainSelector);
  const t = useTranslator();
  const dispatch = useDispatch();

  const handleClick = useCallback(() => {
    if (isIOS() && !isPWA()) {
      dispatch(mainActions.setPopup(<PwaModal />));
      return;
    }

    if (Notification.permission === 'denied') {
      alert(t('notify_denied'));
    } else {
      subscribe(dispatch);
    }
  }, [dispatch, t]);

  if (isNotifyEnabled || (!isNotificationsSupported() && (!isIOS() || isPWA()))) {
    return null;
  }

  return (
    <div className="NotifyRequest" onClick={handleClick}>
      <div className="NotifyRequest__in">
        <div className="NotifyRequest__cont">
          <div className="NotifyRequest__title">{t('notify_push_enable_title')}</div>
          <div className="NotifyRequest__caption">{t('notify_push_enable_caption')}</div>
        </div>
        <Button size="small">{t('notify_push_enable_btn')}</Button>
      </div>
    </div>
  );
};
